document.addEventListener('DOMContentLoaded', function() {
    // Get current page path
    const currentPath = window.location.pathname;
    
    // Function to normalize URLs for comparison
    function normalizeUrl(url) {
        // Remove protocol and domain if present
        url = url.replace(/^https?:\/\/[^\/]+/, '');
        // Remove trailing slashes
        url = url.replace(/\/$/, '');
        // Remove any query parameters
        url = url.split('?')[0];
        return url;
    }

    // Normalize current path
    const normalizedCurrentPath = normalizeUrl(currentPath);

    // Process all links in the navigation
    const navLinks = document.querySelectorAll('.posts__section-navigation a[href]');
    
    // First, find any matching links in primary nav
    let primaryNavMatch = false;
    const primaryNavLinks = document.querySelectorAll('.posts__section-navigation__links > .nav a[href]');
    
    primaryNavLinks.forEach(link => {
        const linkUrl = link.getAttribute('href');
        if (linkUrl) {
            const normalizedLinkUrl = normalizeUrl(linkUrl);
            
            if (normalizedLinkUrl === normalizedCurrentPath) {
                // Found a match in primary nav
                primaryNavMatch = true;
                link.classList.add('nav-current');
            }
        }
    });
    
   
    
    // Now process all other links
    navLinks.forEach(link => {
        // Skip links we've already processed
        if (link.classList.contains('nav-current')) {
            return;
        }
        
        const linkUrl = link.getAttribute('href');
        if (linkUrl) {
            const normalizedLinkUrl = normalizeUrl(linkUrl);
            
            if (normalizedLinkUrl === normalizedCurrentPath) {
                link.classList.add('nav-current');
            }
        }
    });
}); 
